<div class="scrollable-container">
  <eds-toggle
    [toggleButtons]="toggleButtons"
    [isNoWrap]="true"
    (toggleActive)="onTabChange($event)"
  ></eds-toggle>
</div>
